import type { ErrorEvent } from "@sentry/react";

/**
 * Reads the response status off a failed-request event.
 *
 * `httpClientIntegration` records it on the `response` context. Parsing the
 * message is a fallback so an event never ends up grouped under an unknown
 * status when the context is missing.
 */
export const getHttpStatusCode = (event: ErrorEvent): number | null => {
  const fromContext = event.contexts?.response?.status_code;
  if (typeof fromContext === "number") return fromContext;

  const message = event.exception?.values?.find((value) =>
    /HTTP Client Error with status code/i.test(value?.value || ""),
  )?.value;
  const parsed = message?.match(/status code:\s*(\d{3})/i)?.[1];

  return parsed ? Number(parsed) : null;
};
